import { ArrowLeft, ShoppingBag } from 'lucide-react'
import { Link, useNavigate } from 'react-router-dom'
import Layout from '../layout/layout'
import ProductSlider from '../sliders/products-slider'
import { FilteredProductsResponse } from '@/entities/api/products/product-filters'

const EmptyCart = ({ products }: { products: FilteredProductsResponse }) => {
	const navigate = useNavigate()
	return (
		<Layout customer={null} token={null}>
			<div className='bg-gradient-to-b from-gray-100 via-gray-50 to-white py-4 sm:py-8'>
				<div className='max-w-full mx-auto px-4 sm:px-6'>
					<div className='flex items-center gap-3 mb-6 sm:mb-8'>
						<button
							onClick={() => navigate(-1)}
							className='p-2 hover:bg-white rounded-xl transition-all'
						>
							<ArrowLeft className='w-5 h-5 text-gray-600' />
						</button>
						<h1 className='text-xl sm:text-2xl font-bold text-gray-900'>
							Carrito de Compras
						</h1>
					</div>

					<div className='bg-white rounded-3xl p-8 sm:p-12 text-center'>
						<div className='w-20 h-20 sm:w-24 sm:h-24 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6'>
							<ShoppingBag className='w-10 h-10 sm:w-12 sm:h-12 text-gray-400' />
						</div>
						<h2 className='text-xl sm:text-2xl font-bold text-gray-900 mb-3'>
							Tu carrito está vacío
						</h2>
						<p className='text-gray-600 mb-8 max-w-md mx-auto text-sm sm:text-base'>
							Explora nuestro catálogo y encuentra productos increíbles para
							agregar a tu carrito.
						</p>
						<div className='flex flex-col sm:flex-row gap-3 justify-center'>
							<Link
								to='/'
								className='cursor-pointer bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-2xl font-semibold transition-all text-sm sm:text-base'
							>
								Explorar Productos
							</Link>
							<button
								onClick={() => navigate(-1)}
								className='border cursor-pointer border-gray-200 text-gray-700 hover:bg-gray-50 px-6 py-3 rounded-2xl font-semibold transition-all text-sm sm:text-base'
							>
								Volver
							</button>
						</div>
					</div>
				</div>
			</div>

			<div className='w-full py-[4vh] px-[2vw] lg:px-[6vw]'>
				<ProductSlider
					title='Explora más opciones'
					category='Otros'
					filteredProducts={products as FilteredProductsResponse}
					haveZone={false}
					customer={null}
					customerId=''
				/>
			</div>
		</Layout>
	)
}

export default EmptyCart
